    const io=new IntersectionObserver((es)=>es.forEach(x=>{if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target);}}),{threshold:.15});
    document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

    /* ---------- STICKY BUY BAR: show after hero, hide while studio is in view ---------- */
    (function(){
      const bar=document.getElementById('buybar');
      const hero=document.querySelector('.hero');
      const studio=document.getElementById('studio');
      if(!bar||!hero||!studio) return;
      let pastHero=false, inStudio=false;
      const sync=()=>{ const show=pastHero&&!inStudio; bar.classList.toggle('show',show); bar.setAttribute('aria-hidden',show?'false':'true'); };
      new IntersectionObserver(([e])=>{ pastHero=!e.isIntersecting; sync(); },{threshold:0}).observe(hero);
      new IntersectionObserver(([e])=>{ inStudio=e.isIntersecting; sync(); },{threshold:.2}).observe(studio);
    })();

    /* ---------- 360 SHOWCASE: autoplay looping product spin ---------- */
    (function(){
      const reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      const vid = document.getElementById('flip-video');
      const poster = document.getElementById('flip-poster');
      const CLIP = window.TVA.spinClip;
      if(!vid) return;
      if(reduce){ poster.style.opacity='1'; return; }   // reduced-motion: keep the static front image, no video

      vid.loop = true; vid.muted = true; vid.playsInline = true;
      // Blob-load for reliable playback regardless of host byte-range support
      fetch(CLIP).then(r=>{ if(!r.ok) throw new Error('HTTP '+r.status); return r.blob(); })
        .then(b=>{ vid.src=URL.createObjectURL(b); vid.load();
          // hero is in view at load, so kick off playback once the clip is ready
          if(inView) vid.play().catch(()=>{}); })
        .catch(()=>{ /* leave the poster in place if the clip is missing */ });
      vid.addEventListener('playing',()=>{ poster.style.opacity='0'; });

      // Only play while the hero is on-screen; pause otherwise to save CPU/battery
      let inView=true;
      const stage = document.querySelector('.hero');
      const vis = new IntersectionObserver((es)=>es.forEach(e=>{
        inView=e.isIntersecting;
        if(inView){ vid.play().catch(()=>{}); } else { vid.pause(); }
      }),{threshold:.15});
      if(stage) vis.observe(stage);
    })();

    /* ---------- PORTRAIT STUDIO ---------- */
    // Your server endpoint: POST multipart field "image" -> JSON { "url": "https://..." }
    const STORE_ENDPOINT = window.TVA.storeEndpoint;
    const STORE_TOKEN    = window.TVA.storeToken;
    const MAX_BYTES=8*1024*1024;
    let photoId=null;   // R2 id returned by /store; attached to the cart line item

    const mock=document.getElementById('mock');
    const mockPhoto=document.getElementById('mock-photo');
    const fileInput=document.getElementById('file');
    const dropzone=document.getElementById('dropzone');
    const dropHint=document.getElementById('drop-hint');
    const enlistBtn=document.getElementById('studio-enlist');
    const statusEl=document.getElementById('studio-status');
    let currentFile=null;         // the uploaded File
    let localPreviewURL=null;     // objectURL of the raw upload

    function setStatus(msg,kind){statusEl.textContent=msg||'';statusEl.className='studio__status'+(kind?' '+kind:'');}
    function setPhoto(src){mockPhoto.src=src;mock.classList.add('has-photo');}

    // --- Enlistment step ritual: photo added (1), number claimed (2), ready to enlist (3) ---
    const steps=[document.getElementById('step-1'),document.getElementById('step-2'),document.getElementById('step-3')];
    function syncSteps(){
      const done=[!!currentFile, !!fVar.value.trim(), false];
      done[2]=done[0]&&done[1];   // step 3 is "ready" only when 1 & 2 are done
      let activeSet=false;
      steps.forEach((el,i)=>{
        el.classList.toggle('done',done[i]);
        const active=!done[i]&&!activeSet;
        el.classList.toggle('active',active);
        if(active) activeSet=true;
      });
    }

    // live text field -> badge + reserved-designation echo (micro-commitment)
    const fVar=document.getElementById('s-variant');
    const mVar=document.getElementById('mock-variant');
    const mNo=document.getElementById('mock-no');
    const reserved=document.getElementById('reserved');
    const reservedNo=document.getElementById('reserved-no');
    fVar.addEventListener('input',()=>{
      const v=fVar.value.trim();
      mVar.textContent=v||'—';
      mNo.textContent=v; mock.classList.toggle('has-no',!!v);
      if(v){ reservedNo.textContent='#'+v; reserved.classList.add('show'); }
      else { reserved.classList.remove('show'); }
      syncSteps();
    });

    function handleFile(file){
      if(!file) return;
      if(!/^image\/(png|jpe?g|webp)$/.test(file.type)){setStatus('Please choose a JPG, PNG or WebP image.','err');return;}
      if(file.size>MAX_BYTES){setStatus('That image is over 8 MB — please pick a smaller one.','err');return;}
      currentFile=file;
      photoId=null;   // new file: re-upload on next enlist
      if(localPreviewURL) URL.revokeObjectURL(localPreviewURL);
      localPreviewURL=URL.createObjectURL(file);
      setPhoto(localPreviewURL);
      dropHint.textContent=file.name;
      setStatus('Dossier photo added ✓','ok');
      syncSteps();
    }

    dropzone.addEventListener('click',()=>fileInput.click());
    dropzone.addEventListener('keydown',(e)=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();fileInput.click();}});
    fileInput.addEventListener('change',(e)=>handleFile(e.target.files[0]));
    ['dragenter','dragover'].forEach(ev=>dropzone.addEventListener(ev,(e)=>{e.preventDefault();dropzone.classList.add('drag');}));
    ['dragleave','drop'].forEach(ev=>dropzone.addEventListener(ev,(e)=>{e.preventDefault();dropzone.classList.remove('drag');}));
    dropzone.addEventListener('drop',(e)=>{if(e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);});

    enlistBtn.addEventListener('click',async()=>{
      if(!currentFile){setStatus('Please upload your dossier photo before enlisting.','err');dropzone.focus();return;}
      if(!fVar.value.trim()){setStatus('Please enter your current number before enlisting.','err');fVar.focus();return;}
      // Upload the photo now (on enlist), then hand off to checkout with its id.
      enlistBtn.disabled=true; mock.classList.add('loading');
      const label=enlistBtn.textContent; enlistBtn.textContent='Enlisting…';
      setStatus('Uploading your dossier photo…');
      try{
        if(!photoId){
          const fd=new FormData(); fd.append('image',currentFile);
          const res=await fetch(STORE_ENDPOINT,{method:'POST',headers:{'X-TVA-Token':STORE_TOKEN},body:fd});
          if(!res.ok) throw new Error('HTTP '+res.status);
          const data=await res.json();
          if(!data.id) throw new Error('No id in response');
          photoId=data.id;
        }
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: window.TVA.variantId,
            quantity: 1,
            properties: {
              'Variant No': fVar.value.trim(),
              '_photo_id': photoId
            }
          })
        });
        if(!addRes.ok) throw new Error('cart/add '+addRes.status);
        window.location.href='/checkout';
      }catch(err){
        setStatus("Couldn't upload your photo — please try again.",'err');
        enlistBtn.disabled=false; enlistBtn.textContent=label; mock.classList.remove('loading');
      }
    });

    // --- Live enlistment counter: ticks up once as the studio comes into view (honest social proof) ---
    (function(){
      const el=document.getElementById('enlist-count');
      if(!el) return;
      const target=2178; let done=false;
      const fmt=(n)=>n.toLocaleString('en-US');
      const run=()=>{
        if(done) return; done=true;
        const start=2100, dur=1100, t0=performance.now();
        const tick=(now)=>{
          const p=Math.min(1,(now-t0)/dur), eased=1-Math.pow(1-p,3);
          el.textContent=fmt(Math.round(start+(target-start)*eased));
          if(p<1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      };
      if(window.matchMedia('(prefers-reduced-motion:reduce)').matches){ el.textContent=fmt(target); return; }
      new IntersectionObserver((es,ob)=>es.forEach(e=>{ if(e.isIntersecting){ run(); ob.disconnect(); } }),{threshold:.4}).observe(el);
    })();
